export const HSL = {
  primary: 'hsl(342, 71%, 45%)',
  primarySoft: 'hsl(342, 71%, 96%)',
  secondary: 'hsl(182, 100%, 31%)',
  secondarySoft: 'hsl(182, 100%, 94%)',
  warning: 'hsl(38, 92%, 50%)',
  warningSoft: 'hsl(38, 92%, 94%)',
  success: 'hsl(142, 65%, 38%)',
  successSoft: 'hsl(142, 65%, 94%)',
  error: 'hsl(0, 84%, 55%)',
  errorSoft: 'hsl(0, 84%, 96%)',
  neutral: 'hsl(0, 0%, 35%)',
  neutralSoft: 'hsl(0, 0%, 96%)',
  border: 'hsl(0, 0%, 85%)',
  textMuted: 'hsl(0, 0%, 45%)',
  textStrong: 'hsl(0, 0%, 20%)',
  surface: 'hsl(0, 0%, 100%)',
};

export const STATUS_COLORS = {
  draft: { bg: HSL.secondarySoft, fg: HSL.secondary, label: 'Draft' },
  held: { bg: HSL.warningSoft, fg: HSL.warning, label: 'Held' },
  publishing: { bg: HSL.primarySoft, fg: HSL.primary, label: 'Publishing' },
  sent: { bg: HSL.successSoft, fg: HSL.success, label: 'Sent' },
  failed: { bg: HSL.errorSoft, fg: HSL.error, label: 'Failed' },
};
